import { Terminal, TerminalContent } from '@crowdex/ui/ai/terminal';
import { ToolContent, ToolHeader } from '@crowdex/ui/ai/tool';
import {
  terminalRunning,
  terminalToolAction,
  terminalToolState,
  terminalToolTitle,
} from '@/lib/conversations/message-part/terminal';
import type { TerminalPart } from '@/lib/conversations/message-part/types';
import { StableTool } from './stable-tool';

export function TerminalToolCard({ data }: { data: TerminalPart['data'] }) {
  return (
    <StableTool className="py-0.5 text-muted-foreground">
      <ToolHeader
        action={terminalToolAction(data.exitCode, data.signal)}
        state={terminalToolState(data.exitCode, data.signal)}
        title={terminalToolTitle(data.exitCode, data.signal)}
        type="tool-terminal"
      />
      <ToolContent className="py-2">
        <Terminal
          className="rounded-md border-hairline bg-desktop-terminal text-desktop-terminal-foreground"
          isStreaming={terminalRunning(data.exitCode, data.signal)}
          output={data.output}
        >
          <TerminalContent className="max-h-64 p-3 text-xs leading-5">
            {data.output.length > 0 ? (
              <pre className="whitespace-pre-wrap break-words">{data.output}</pre>
            ) : (
              <span className="text-desktop-terminal-foreground/70">
                {terminalRunning(data.exitCode, data.signal)
                  ? 'Terminal running…'
                  : 'No terminal output.'}
              </span>
            )}
          </TerminalContent>
        </Terminal>
      </ToolContent>
    </StableTool>
  );
}
